import React, { useState, useEffect, useRef } from "react";
import HeaderDashboard from "../components/HeaderDashboard";
import { Box, Typography, Button, Avatar, IconButton, Dialog, Divider } from "@mui/material";

import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ReceiptIcon from '@mui/icons-material/Receipt';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import DatasetIcon from '@mui/icons-material/Dataset';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router-dom";
import QrCodeIcon from '@mui/icons-material/QrCode';
import { useUser } from "../../contexts/UserContext";
import { MascaraCnpj } from "../../utils/MascaraCnpj";
import {
    ResponsiveContainer,
    AreaChart,
    Area,
    XAxis,
    YAxis,
    Tooltip
} from "recharts";
import Loading from "../components/Loading";
import Seo from "../../components/Seo";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import AlertSuccess from "../components/AlertSuccess";


const Dashboard = () => {
    const navigate = useNavigate();


    const obrigacoesRef = useRef(null);
    const irParaObrigacoes = () => {
        obrigacoesRef.current.scrollIntoView({
            behavior: "smooth",
        });
    };

    const { user } = useUser();
    console.log("Dados do usuário no dashboard:", user);
    const [userLoaded, setUserLoaded] = useState(false);
    const [openPreview, setOpenPreview] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [hasObrigacoes, setHasObrigacoes] = useState(false);
    const [obrigacoes, setObrigacoes] = useState([]);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [mensagem, setMensagem] = useState("");

    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!token) navigate("../Login");
    }, [token, navigate]);

    useEffect(() => {
        if (!user) return;

        setUserLoaded(true);

        const hoje = new Date(); // Data fixa para teste

        const obrigacoesMesAtual = (user.guias || []).filter((obrigacao) => {
            if (!obrigacao.vencimento) return false;

            // Formato esperado: dd/MM/yyyy
            const [dia, mes, ano] = obrigacao.vencimento.split("/");

            const vencimento = new Date(
                Number(ano),
                Number(mes) - 1,
                Number(dia)
            );

            return ( 
                vencimento.getMonth() === hoje.getMonth() &&
                vencimento.getFullYear() === hoje.getFullYear() &&
                vencimento >= hoje
            );
        });

        setObrigacoes(obrigacoesMesAtual);
        setHasObrigacoes(obrigacoesMesAtual.length > 0);
    }, [user]);

    // useEffect(() => {
    //     if (!user) {
    //         setLoading(true);
    //         return;
    //     }
    //     setUserLoaded(true);
    //     setLoading(false);
    // }, [user]);


    const pendenciasCadastrais = [
        !user?.fichaCadastral,
        !user?.documentos,
        !user?.certificado
    ].filter(Boolean).length;

    const pendentes = user?.faturas?.pendentes?.length || 0;
    const vencidas = user?.faturas?.vencidas?.length || 0;
    const total = pendentes + vencidas;

    const notasEmitidasHoje = user?.listNotasFiscaisEmitidas.map(nota => {
        const dataEmissao = new Date(nota.dataEmissao);
        const hoje = new Date();
        return dataEmissao.toDateString() === hoje.toDateString() && (nota.status === "PENDENTE" || nota.status === "AUTHORIZED");
    }).filter(Boolean).length || 0;

    const faturamentoMensal = user?.listNotasFiscaisEmitidas.reduce((total, nota) => {
        const dataEmissao = new Date(nota.dataEmissao);
        const hoje = new Date();
        if (dataEmissao.getMonth() === hoje.getMonth() && dataEmissao.getFullYear() === hoje.getFullYear() && (nota.status === "PENDENTE" || nota.status === "AUTHORIZED")) {
            return total + Number(nota.valor);
        }
        return total;
    }, 0) || 0;

    const porcentagemFaturamentoMesAnterior = user?.graficoFaturamento && user.graficoFaturamento.length > 1 ? ((user.graficoFaturamento[user.graficoFaturamento.length - 1].faturamento - user.graficoFaturamento[user.graficoFaturamento.length - 2].faturamento) / user.graficoFaturamento[user.graficoFaturamento.length - 2].faturamento) * 100 : 0;

    const handleDownload = async (filePath) => {
        const url = new URL(filePath, process.env.REACT_APP_API_URL).toString();

        const response = await fetch(url);
        const blob = await response.blob();

        const downloadUrl = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = filePath.split("/").pop(); // nome do arquivo
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(downloadUrl);
    };

    const handleView = (filePath) => {
        const url = new URL(filePath, process.env.REACT_APP_API_URL).toString();
        setImageUrl(url);
        setOpenPreview(true);
    };

    return (
        <>
            <Seo
                title="Contblack | Dashboard"
                description="Acesse sua conta Contblack e gerencie suas finanças, serviços e documentos de forma prática e eficiente."
            />
            <HeaderDashboard />

            <div style={{ width: "80%", height: "fit-content", margin: "60px auto 0 auto" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", marginBottom: "40px", flexWrap: "wrap" }} >
                    {hasObrigacoes && (
                        <Box sx={{ width: { xs: "100%", md: "45%", }, minHeight: "80px", border: "1px solid #ff0000", backgroundColor: "#ff00001c", borderRadius: "15px 0 15px 0", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: { xs: "wrap", md: "nowrap", }, gap: 2, padding: 2, marginTop: "10px" }} >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, }} >
                                <ReportGmailerrorredIcon sx={{ color: "red", fontSize: "40px", flexShrink: 0, }} />
                                <Typography sx={{ fontWeight: 600, fontSize: { xs: "14px", md: "16px", }, }} >
                                    Você possui obrigações a pagar
                                </Typography>
                            </Box>
                            <span style={{ color: "#ff0000", cursor: "pointer" }} onClick={irParaObrigacoes} >
                                PAGAR AGORA
                            </span>
                        </Box>
                    )}
                    {pendenciasCadastrais > 0 && userLoaded && (
                        <Box sx={{ width: { xs: "100%", md: "45%", }, minHeight: "80px", border: "1px solid #ffae00", backgroundColor: "#ffae001c", borderRadius: "15px 0 15px 0", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: { xs: "wrap", md: "nowrap", }, gap: 2, padding: 2, marginTop: "10px" }} >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
                                <WarningAmberIcon
                                    sx={{
                                        color: "#ffae00",
                                        fontSize: "40px",
                                        flexShrink: 0,
                                    }}
                                />
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: {
                                            xs: "14px",
                                            md: "16px",
                                        },
                                    }}
                                >
                                    Você possui {pendenciasCadastrais} pendência{pendenciasCadastrais > 1 ? "s" : ""} cadastral{pendenciasCadastrais > 1 ? "is" : ""}
                                </Typography>
                            </Box>
                            {/* <span style={{ color: "#ffae00", }} >
                            VER PENDÊNCIAS
                            </span> */}
                        </Box>
                    )}
                </div>

                {/* nova seção */}
                <Box sx={{ width: "100%", backgroundColor: "#233344", color: "#fff", border: "1px solid #233344", borderRadius: "15px 0 15px 0", p: 3, display: "flex", flexDirection: { xs: "column", md: "row", }, justifyContent: "space-between", alignItems: { xs: "flex-start", md: "center", }, gap: 3, }} >
                    <Box sx={{ flex: 1, width: "100%" }}>
                        <Typography sx={{ fontWeight: 600, fontSize: { xs: "20px", md: "24px", }, }} >
                            Olá, {user?.usuario?.Nome?.split(" ")[0] || "..."} 👋
                        </Typography>

                        <Typography sx={{ fontWeight: 300, fontSize: { xs: "14px", md: "16px", }, mt: 0.5, color: "#c8d2dc", }} >
                            Bem-vindo ao seu painel Contblack!
                        </Typography>

                        <Box sx={{ mt: 4, display: "flex", flexWrap: "wrap", gap: { xs: 2, md: 5, }, }} >
                            <Box>
                                <Typography sx={{ fontWeight: 600, fontSize: "12px", color: "#7d8b99", letterSpacing: "1px", }} >
                                    CNPJ
                                </Typography>

                                <Typography sx={{ fontWeight: 400, fontSize: "14px", }} >
                                    {MascaraCnpj(user?.empresa?.cnpj) || "..."}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ fontWeight: 600, fontSize: "12px", color: "#7d8b99", letterSpacing: "1px", }}>
                                    REGIME
                                </Typography>
                                <Typography sx={{ fontWeight: 400, fontSize: "14px", }} >
                                    {user?.empresa?.taxRegime ? (
                                        user.empresa.taxRegime === "simplesNacional" ? "Simples Nacional" :
                                            user.empresa.taxRegime === "simplesNacionalExcessoSublimite" ? "Simples Nacional — Excesso de sublimite de receita bruta" :
                                                user.empresa.taxRegime === "regimeNormal" ? "Regime Normal (Lucro Presumido ou Lucro Real)" :
                                                    user.empresa.taxRegime === "simplesNacionalMEI" ? "MEI (Microempreendedor individual)" :
                                                        "Outro"
                                    ) : "..."}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ width: { xs: "100%", md: "220px", }, minHeight: "100px", backgroundColor: "#32404f", borderRadius: "15px 0 15px 0", display: "flex", flexDirection: "column", justifyContent: "center", p: 2.5, }} >
                        <Typography sx={{ fontWeight: 300, fontSize: "11px", color: "#c8d2dc", letterSpacing: "1px", }} >
                            PLANO ATUAL
                        </Typography>
                        <Typography sx={{ fontWeight: 700, fontSize: "22px", color: "#1EFF86", mt: 0.5, }} >
                            {user?.plano?.nome || "..."}
                        </Typography>
                        <Typography sx={{ fontWeight: 300, fontSize: "11px", color: "#c8d2dc", letterSpacing: "1px", cursor: "pointer", "&:hover": { textDecoration: "underline", color: "#1EFF86" }, }} onClick={() => navigate("../dashboard/assinatura")} >
                            Ver detalhes do plano
                        </Typography>
                    </Box>
                </Box>
            </div>

            {/* nova seção - ações rápidas */}
            <Box sx={{ width: "80%", margin: "40px auto", display: "flex", flexWrap: "wrap", gap: 3, justifyContent: "space-between", }} >
                <Box sx={{ width: window.innerWidth < 900 ? "130px" : "250px", minHeight: "140px", borderRadius: "15px 0 15px 0", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2, padding: 2, cursor: "pointer", border: "1px solid #727f8d", "&:hover": { backgroundColor: "#B000FF10", }, }}
                    onClick={() => {
                        const limite = user?.plano?.qtdNfseMensalUsuario;
                        const emitidas = user?.notasEmitidasEsteMes || 0;
                        const podeEmitir = user?.empresa && (limite === -1 || emitidas < (limite ?? 0));
                        console.log("Verificando permissão para emitir nota:", { limite, emitidas, podeEmitir });
                        if (podeEmitir) {
                            navigate("../dashboard/emitirNotaServico");
                        } else {
                            alert("Você atingiu o limite mensal de emissão de notas fiscais para o seu plano. Por favor, aguarde o próximo mês ou entre em contato para atualizar seu plano.");
                        }
                    }}
                >
                    <div style={{ width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#9d01b928", borderRadius: "50%" }} >
                        <ReceiptIcon sx={{ color: "#9C01B9", fontSize: "30px", flexShrink: 0, }} />
                    </div>
                    <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "black", textAlign: "center", }} >
                        Emitir nota fiscal
                    </Typography>
                    {user?.plano?.qtdNfseMensalUsuario !== -1 &&
                        user?.notasEmitidasEsteMes >= (user?.plano?.qtdNfseMensalUsuario ?? 0) && (
                            <Typography sx={{ fontWeight: 600, fontSize: "16px", color: "orange", textAlign: "center", }} >
                                Limite mensal atingido
                            </Typography>
                        )}
                </Box>
                <Box sx={{ width: window.innerWidth < 900 ? "130px" : "250px", minHeight: "140px", borderRadius: "15px 0 15px 0", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2, padding: 2, cursor: "pointer", border: "1px solid #727f8d", "&:hover": { backgroundColor: "#B000FF10", }, }}
                    onClick={() => navigate("../dashboard/certificado")}
                >
                    <div style={{ width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#9d01b928", borderRadius: "50%" }} >
                        <DatasetIcon sx={{ color: "#9C01B9", fontSize: "30px", flexShrink: 0, }} />
                    </div>
                    <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "black", textAlign: "center", }} >
                        Minha empresa
                    </Typography>
                </Box>
                <Box sx={{ width: window.innerWidth < 900 ? "130px" : "250px", minHeight: "140px", borderRadius: "15px 0 15px 0", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2, padding: 2, cursor: "pointer", border: "1px solid #727f8d", "&:hover": { backgroundColor: "#B000FF10", }, }}
                    onClick={() => navigate("../dashboard/servicos")}
                >
                    <div style={{ width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#9d01b928", borderRadius: "50%" }} >
                        <HomeRepairServiceIcon sx={{ color: "#9C01B9", fontSize: "30px", flexShrink: 0, }} />
                    </div>
                    <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "black", textAlign: "center", }} >
                        Meus Serviços
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: window.innerWidth < 900 ? "130px" : "250px",
                        minHeight: "140px",
                        borderRadius: "15px 0 15px 0",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1,
                        padding: 2,
                        cursor: "pointer",
                        border: "1px solid #727f8d",
                        "&:hover": {
                            backgroundColor: "#B000FF10",
                        },
                    }}
                    onClick={() => navigate("../dashboard/faturas/pendentes")}
                >
                    <div
                        style={{
                            width: "50px",
                            height: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#9d01b928",
                            borderRadius: "50%",
                        }}
                    >
                        <TrendingUpIcon
                            sx={{
                                color: "#9C01B9",
                                fontSize: "30px",
                                flexShrink: 0,
                            }}
                        />
                    </div>

                    <Typography
                        sx={{
                            // fontWeight: 600,
                            fontSize: "16px",
                            color: "black",
                            textAlign: "center",
                        }}
                    >
                        Faturas Pendentes
                    </Typography>

                    {total > 0 ? (
                        <>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: "18px",
                                    color: "red",
                                    textAlign: "center",
                                }}
                            >
                                {total} fatura{total > 1 ? "s" : ""}
                            </Typography>

                            {/* {vencidas > 0 && (
                                <Typography
                                    sx={{
                                        fontSize: "12px",
                                        color: "#D32F2F",
                                        fontWeight: 600,
                                        textAlign: "center",
                                    }}
                                >
                                    {vencidas} vencida{vencidas > 1 ? "s" : ""}
                                </Typography>
                            )} */}
                        </>
                    ) : (
                        <Typography
                            sx={{
                                fontSize: "13px",
                                color: "#2E7D32",
                                fontWeight: 600,
                                textAlign: "center",
                            }}
                        >
                            Nenhuma pendência
                        </Typography>
                    )}
                </Box>
                <Box sx={{ width: window.innerWidth < 900 ? "130px" : "250px", minHeight: "140px", borderRadius: "15px 0 15px 0", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2, padding: 2, cursor: "pointer", border: "1px solid #727f8d", "&:hover": { backgroundColor: "#B000FF10", }, }}
                    onClick={() => navigate("../dashboard/faturas/pagas")}
                >
                    <div style={{ width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#9d01b928", borderRadius: "50%" }} >
                        <CreditCardIcon sx={{ color: "#9C01B9", fontSize: "30px", flexShrink: 0, }} />
                    </div>
                    <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "black", textAlign: "center", }} >
                        Faturas Pagas
                    </Typography>
                </Box>
            </Box>

            {/* nova seção - gráficos e dados (ainda não implementada) */}
            <Box sx={{ mt: 3, width: "80%", margin: "0 auto 40px auto" }} >
                <Typography sx={{ fontSize: { xs: "18px", md: "22px", }, fontWeight: 500, mb: 2, color: "#233344", }} >
                    Sua empresa hoje
                </Typography>

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(4, 1fr)", }, gap: 2, }} >
                    {/* Pendências */}
                    <Box sx={{ minHeight: 140, backgroundColor: "#fff", borderRadius: "20px 0 20px 0", borderLeft: `4px solid ${!user?.fichaCadastral ? "#FFB300" : "#1EFF86"}`, borderTop: `1px solid ${!user?.fichaCadastral ? "#FFB300" : "#1EFF86"}`, borderRight: `1px solid ${!user?.fichaCadastral ? "#FFB300" : "#1EFF86"}`, borderBottom: `1px solid ${!user?.fichaCadastral ? "#FFB300" : "#1EFF86"}`, p: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", cursor: "pointer", "&:hover": { boxShadow: `0 0 10px ${!user?.fichaCadastral ? "#FFB300" : "#1EFF86"}`, transition: "box-shadow 0.3s ease", }, }} >
                        <Typography sx={{ fontWeight: 700, color: "#233344" }}>
                            PENDÊNCIAS CADASTRAIS
                        </Typography>

                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 700, fontSize: "24px" }}>
                                {!user?.fichaCadastral ? "Pendente" : "EM DIA"}
                            </Typography>

                            <Box sx={{ width: 12, height: 12, borderRadius: "50%", backgroundColor: !user?.fichaCadastral ? "#FFB300" : "#1EFF86", }} />
                        </Box>
                    </Box>

                    <Box sx={{ minHeight: 140, backgroundColor: "#fff", borderRadius: "20px 0 20px 0", borderLeft: `4px solid ${!user?.documentos ? "#FFB300" : "#1EFF86"}`, borderTop: `1px solid ${!user?.documentos ? "#FFB300" : "#1EFF86"}`, borderRight: `1px solid ${!user?.documentos ? "#FFB300" : "#1EFF86"}`, borderBottom: `1px solid ${!user?.documentos ? "#FFB300" : "#1EFF86"}`, p: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", cursor: "pointer", "&:hover": { boxShadow: `0 0 10px ${!user?.fichaCadastral ? "#FFB300" : "#1EFF86"}`, transition: "box-shadow 0.3s ease", }, }}
                        onClick={() => navigate("../dashboard/documentos")}
                    >
                        <Typography sx={{ fontWeight: 700, color: "#233344" }}>
                            PENDÊNCIAS DOCUMENTAIS
                        </Typography>

                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 700, fontSize: "24px" }}>
                                {!user?.documentos ? "Pendente" : "EM DIA"}
                            </Typography>

                            <Box sx={{ width: 12, height: 12, borderRadius: "50%", backgroundColor: !user?.documentos ? "#FFB300" : "#1EFF86", }} />
                        </Box>
                    </Box>

                    {/* Certificado */}
                    <Box sx={{ minHeight: 140, backgroundColor: "#fff", borderRadius: "20px 0 20px 0", borderLeft: `4px solid ${user?.certificado && user?.empresa ? "#1EFF86" : "#FFB300"}`, borderTop: `1px solid ${user?.certificado && user?.empresa ? "#1EFF86" : "#FFB300"}`, borderRight: `1px solid ${user?.certificado && user?.empresa ? "#1EFF86" : "#FFB300"}`, borderBottom: `1px solid ${user?.certificado && user?.empresa ? "#1EFF86" : "#FFB300"}`, p: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", cursor: "pointer", "&:hover": { boxShadow: `0 0 10px ${user?.certificado && user?.empresa ? "#1EFF86" : "#FFB300"}`, transition: "box-shadow 0.3s ease", } }}
                    // onClick={() => navigate("../dashboard/certificado")}
                    >
                        <Typography sx={{ fontWeight: 700, color: "#233344" }}>
                            {user?.certificado && user?.empresa ? "EMPRESA CONFIGURADA" : "EMPRESA EM CONFIGURAÇÃO"}
                        </Typography>

                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 700, fontSize: "24px" }}>
                                {user?.certificado && user?.empresa ? "Habilitada" : "Pendente"}
                            </Typography>

                            <Box sx={{ width: 12, height: 12, borderRadius: "50%", backgroundColor: user?.certificado && user?.empresa ? "#1EFF86" : "#FFB300", }} />
                        </Box>
                    </Box>

                    {/* Fiscal */}
                    <Box sx={{ minHeight: 140, backgroundColor: "#fff", borderRadius: "20px 0 20px 0", borderLeft: "4px solid #B000FF", borderTop: "1px solid #B000FF", borderRight: "1px solid #B000FF", borderBottom: "1px solid #B000FF", p: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", cursor: "pointer", "&:hover": { boxShadow: `0 0 10px #B000FF`, transition: "box-shadow 0.3s ease", } }}
                        onClick={() => navigate("../dashboard/notasFiscaisEmitidas")}
                    >
                        <Typography sx={{ fontWeight: 700, color: "#233344" }}>
                            FISCAL / MÊS
                        </Typography>

                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 700, fontSize: "24px" }}>
                                {user?.notasEmitidasEsteMes >= 0 ? `${user.notasEmitidasEsteMes} Notas` : "0 Notas"}
                            </Typography>

                            <Typography sx={{ color: "#B000FF", fontWeight: 700, fontSize: "14px", }} >
                                +{notasEmitidasHoje} hoje
                            </Typography>
                        </Box>
                    </Box>



                    {/* Obrigações
                    <Box sx={{ minHeight: 140, backgroundColor: "#fff", borderRadius: "20px 0 20px 0", borderLeft: "4px solid #B000FF", borderTop: "1px solid #B000FF", borderRight: "1px solid #B000FF", borderBottom: "1px solid #B000FF", p: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", cursor: "pointer", "&:hover": { boxShadow: `0 0 10px #B000FF`, transition: "box-shadow 0.3s ease", } }} >
                        <Typography sx={{ fontWeight: 700, color: "#233344" }}>
                            OBRIGAÇÕES
                        </Typography>

                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 700, fontSize: "24px" }}>
                                DAS em 5 dias
                            </Typography>
                            <CalendarMonthIcon sx={{ color: "#B000FF", fontSize: "28px", }} />
                        </Box>
                    </Box> */}
                </Box>
            </Box>
            <Box sx={{ mt: 3, width: "80%", margin: "0 auto 40px auto", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }} >
                {/* Faturamento */}
                <Box sx={{ width: window.innerWidth < 900 ? "100%" : "49%", backgroundColor: "#fff", borderRadius: "20px", border: "1px solid #e5e5e5", p: 4, minHeight: 320, display: "flex", flexDirection: "column", justifyContent: "space-between", }} >
                    <Box display="flex" justifyContent="space-between">
                        <Box>
                            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#233344", }} >
                                FATURAMENTO MENSAL (na plataforma)
                            </Typography>

                            <Typography sx={{ mt: 1, fontSize: "32px", fontWeight: 700, color: "#0a2239", }} >
                                R$ {faturamentoMensal.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>

                            <Typography sx={{ mt: 1, color: porcentagemFaturamentoMesAnterior >= 0 ? "#009944" : "#FF0000", fontWeight: 600, fontSize: "16px", }} >
                                ↗ {porcentagemFaturamentoMesAnterior.toFixed(2)}% vs mês anterior
                            </Typography>
                        </Box>

                        <Box sx={{ width: 48, height: 48, backgroundColor: "#f2f2f2", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", }} >
                            <TrendingUpIcon sx={{ color: "#233344" }} />
                        </Box>
                    </Box>

                    {/* Gráfico fake */}
                    <Box
                        sx={{
                            width: "100%",
                            height: 250,
                            background: "#fff",
                            borderRadius: "20px",
                            p: 2,
                        }}
                    >
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={user?.graficoFaturamento || []} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                                <defs>
                                    <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#1EFF86" stopOpacity={0.4} />
                                        <stop offset="95%" stopColor="#1EFF86" stopOpacity={0} />
                                    </linearGradient>
                                </defs>

                                <XAxis
                                    dataKey="mes"
                                    tick={{ fontSize: 12 }}
                                    axisLine={false}
                                    tickLine={false}
                                />

                                <YAxis
                                    hide
                                />

                                <Tooltip
                                    formatter={(value) =>
                                        new Intl.NumberFormat("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                        }).format(value)
                                    }
                                />

                                <Area
                                    type="monotone"
                                    dataKey="faturamento"
                                    stroke="#1EFF86"
                                    strokeWidth={3}
                                    fillOpacity={1}
                                    fill="url(#colorRevenue)"
                                />
                            </AreaChart>
                        </ResponsiveContainer>
                    </Box>
                </Box>

                {/* Impostos */}
                <Box ref={obrigacoesRef} sx={{ width: window.innerWidth < 900 ? "100%" : "49%", backgroundColor: "#fff", borderRadius: "20px", border: "1px solid #e5e5e5", p: 4, minHeight: 320, display: "flex", flexDirection: "column", }} >
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#233344", mb: 3, }} >
                        VISÃO GERAL DAS OBRIGAÇÕES
                    </Typography>

                    {hasObrigacoes ? (
                        obrigacoes.map((obrigacao, index) => (
                            <>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 2,
                                        flexWrap: "wrap",
                                        gap: 2,
                                    }}
                                >
                                    <Box display="flex" gap={2}>
                                        <Box
                                            sx={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: "50%",
                                                background: "#FFF3D6",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <DescriptionOutlinedIcon sx={{ color: "#D89000" }} />
                                        </Box>

                                        <Box>
                                            <Typography fontWeight={700}>
                                                {obrigacao.tipo}
                                            </Typography>

                                            <Typography color="#555">
                                                Vencimento: {obrigacao.vencimento}
                                            </Typography>
                                            <Typography
                                                fontSize={12}
                                                mt={0.8}
                                                sx={{
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    cursor: "pointer",
                                                    color: "#1976d2",
                                                    "&:hover": {
                                                        textDecoration: "underline",
                                                    },
                                                }}
                                                onClick={() => handleDownload(obrigacao.caminhoArquivo)}
                                            >
                                                <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />
                                                {" "} Download boleto
                                            </Typography>
                                            <Typography
                                                color="#555"
                                                fontSize={12}
                                                mt={0.5}
                                                sx={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    cursor: "pointer",
                                                    "&:hover": { textDecoration: "underline" },
                                                    color: "#B000FF",
                                                }}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(obrigacao.dadosExtraidos.codigoBarras);
                                                    setOpenSnackbarSuccess(true);
                                                    setMensagem("Código de barras copiado para a área de transferência!");
                                                }}
                                            >
                                                <QrCodeIcon sx={{ fontSize: 14 }} />
                                                Copiar código de barras para pagamento
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box textAlign="right">
                                        <Typography fontWeight={700}>
                                            R$ {obrigacao.dadosExtraidos.valorTotal.replace(".", ",")}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                mt: 0.5,
                                                display: "inline-block",
                                                px: 1.5,
                                                py: 0.2,
                                                borderRadius: "10px",
                                                backgroundColor: "#FFF3D6",
                                                color: "#D89000",
                                                fontSize: "12px",
                                                fontWeight: 700,
                                            }}
                                        >
                                            AGUARDANDO
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider sx={{ borderColor: "#eee", mb: 2 }} />

                            </>
                        ))
                    ) : (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                py: 6,
                                px: 3,
                                borderRadius: 3,
                                backgroundColor: "#F8FAFC",
                                border: "1px solid #E2E8F0",
                                gap: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: "100%",
                                    borderRadius: "50%",
                                    backgroundColor: "#ECFDF5",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 28,
                                }}
                            >
                                ✅
                            </Box>

                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 600, color: "#1E293B" }}
                            >
                                Nenhuma obrigação pendente
                            </Typography>

                            <Typography
                                variant="body1"
                                sx={{ color: "#64748B", maxWidth: 400 }}
                            >
                                Não encontramos guias de impostos ou obrigações acessórias em aberto.
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{ color: "#16A34A", fontWeight: 600 }}
                            >
                                Você está em dia com suas obrigações fiscais.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box >

            <Box sx={{ mt: 3, width: "80%", margin: "0 auto 40px auto", display: "flex", gap: 2, alignItems: "stretch", flexWrap: "wrap", justifyContent: "space-between" }} >
                {/* ===================== DOCUMENTOS ===================== */}
                <Box
                    sx={{
                        width: {
                            xs: "100%",
                            md: "73%",
                        },
                        background: "#fff",
                        borderRadius: "20px",
                        border: "1px solid #E8E8E8",
                        overflow: "hidden",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            px: { xs: 2, md: 3 },
                            py: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                color: "#233344",
                                fontSize: {
                                    xs: 16,
                                    md: 18,
                                },
                            }}
                        >
                            Central de Documentos
                        </Typography>

                        <Typography
                            sx={{
                                color: "#B000FF",
                                fontWeight: 700,
                                cursor: "pointer",
                                fontSize: {
                                    xs: 14,
                                    md: 16,
                                },
                            }}
                        >
                            Ver todos
                        </Typography>
                    </Box>

                    {/* Cabeçalho desktop */}
                    <Box
                        sx={{
                            display: {
                                xs: "none",
                                md: "grid",
                            },
                            gridTemplateColumns: "2fr 1.5fr 120px",
                            px: 3,
                            py: 2,
                            color: "#777",
                            fontWeight: 700,
                            fontSize: 13,
                            borderTop: "1px solid #F0F0F0",
                        }}
                    >
                        <Typography fontWeight={700}>
                            DOCUMENTO
                        </Typography>

                        <Typography fontWeight={700}>
                            TIPO
                        </Typography>

                        <Typography fontWeight={700}>
                            AÇÕES
                        </Typography>
                    </Box>

                    {[
                        {
                            nome: "Contrato Social",
                            tipo: "Empresarial",
                            icon: <DescriptionOutlinedIcon />,
                            download: user?.documentos?.contratoSocialFileName || null,
                        },
                        // {
                        //     nome: "Certificado Digital",
                        //     tipo: "Token/Arquivo",
                        //     icon: <VerifiedUserOutlinedIcon />,
                        // },
                        {
                            nome: "CNH / RG",
                            tipo: "Pessoal",
                            icon: <InsertDriveFileOutlinedIcon />,
                            download: user?.documentos?.rgCnhFileName || null,
                        },
                        {
                            nome: "Comprovante de endereço",
                            tipo: "Pessoal",
                            icon: <InsertDriveFileOutlinedIcon />,
                            download: user?.documentos?.comprovanteResidenciaFileName || null,
                        },
                        {
                            nome: "Titulo de eleitor",
                            tipo: "Pessoal",
                            icon: <InsertDriveFileOutlinedIcon />,
                            download: user?.documentos?.tituloEleitorFileName || null,
                        },
                        // {
                        //     nome: "Relatório Trimestral",
                        //     tipo: "Financeiro",
                        //     icon: <InsertDriveFileOutlinedIcon />,
                        //     download: null,
                        // },
                    ].map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "1fr",
                                    md: "2fr 1.5fr 120px",
                                },
                                gap: {
                                    xs: 1.5,
                                    md: 0,
                                },
                                alignItems: "center",
                                px: {
                                    xs: 2,
                                    md: 3,
                                },
                                py: 2.5,
                                borderTop: "1px solid #F5F5F5",
                            }}
                        >
                            {/* Documento */}
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={2}
                            >
                                <Box sx={{ color: "#B000FF" }}>
                                    {item.icon}
                                </Box>

                                <Typography
                                    fontWeight={500}
                                    fontSize={{
                                        xs: 14,
                                        md: 16,
                                    }}
                                >
                                    {item.nome}
                                </Typography>
                            </Box>

                            {/* Tipo */}
                            <Typography
                                color="#555"
                                fontSize={{
                                    xs: 14,
                                    md: 15,
                                }}
                            >
                                <Box
                                    component="span"
                                    sx={{
                                        display: {
                                            xs: "inline",
                                            md: "none",
                                        },
                                        fontWeight: 700,
                                        color: "#233344",
                                    }}
                                >
                                    Tipo:{" "}
                                </Box>

                                {item.tipo}
                            </Typography>

                            {/* Ações */}
                            <Box
                                display="flex"
                                gap={1}
                                justifyContent={{
                                    xs: "flex-start",
                                    md: "flex-start",
                                }}
                            >
                                <IconButton size="small" disabled={!item.download || item.tipo === "Empresarial"} onClick={() => handleView(item.download)}>
                                    <VisibilityOutlinedIcon
                                        sx={{ color: item.download && item.tipo !== "Empresarial" ? "#B000FF" : "#ccc" }}
                                    />
                                </IconButton>

                                <IconButton size="small"
                                    disabled={!item.download}
                                    onClick={() => handleDownload(item.download)}
                                >
                                    <DownloadOutlinedIcon
                                        sx={{ color: item.download ? "#B000FF" : "#ccc" }}
                                    />
                                </IconButton>
                            </Box>
                        </Box>
                    ))}
                </Box>

                {/* ===================== CONTADOR ===================== */}

                <Box sx={{ width: window.innerWidth < 900 ? "100%" : "25%", borderRadius: "20px", background: "linear-gradient(180deg,#C300FF 0%, #9300CC 100%)", color: "#fff", p: 4, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", }} >
                    <Typography sx={{ fontWeight: 700, fontSize: 15, mb: 3, }} >
                        ATENDIMENTO DEDICADO
                    </Typography>
                    <Avatar src="/assets/dennisContador.jpeg" sx={{ width: 100, height: 100, border: "4px solid rgba(255,255,255,.25)", mb: 2, }} />
                    <Typography sx={{ fontWeight: 700, fontSize: 20, }} >
                        Dennis Nardelli
                    </Typography>

                    <Typography sx={{ mt: 1, opacity: .95, fontSize: 15, lineHeight: 1.6, }} >
                        Seu especialista em gestão fiscal e estratégica.
                    </Typography>

                    <Button sx={{ mt: 4, background: "#1EFF86", color: "#004E25", fontWeight: 700, borderRadius: "12px", px: 3, py: 1.4, "&:hover": { background: "#19e67a", }, }} onClick={() => window.open(gerarLinkWhatsApp("Olá, sou cliente e gostaria de falar com meu contador."), "_blank")} >
                        FALAR COM MEU CONTADOR
                    </Button>

                    {/* <Typography sx={{ mt: "auto", pt: 3, fontSize: 12, opacity: .7, }} >
                        © Contador Certificado CRC-PR 123456
                    </Typography> */}
                </Box>
            </Box>

            <Box
                sx={{
                    mt: 3,
                    width: {
                        xs: "80%",
                        sm: "80%",
                        md: "80%",
                    },
                    margin: "0 auto 56px auto",
                    background: "#fff",
                    border: "1px solid #E8E8E8",
                    borderRadius: "20px",
                    p: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                    },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    gap: 4,
                }}
            >
                {/* Informações */}
                <Box flex={1} width="80%">
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1.5}
                        flexWrap="wrap"
                    >
                        <Typography
                            sx={{
                                fontSize: {
                                    xs: 20,
                                    md: 24,
                                },
                                fontWeight: 700,
                                color: "#233344",
                            }}
                        >
                            Plano {user?.plano?.nome || "..."}
                        </Typography>

                        <Box
                            sx={{
                                px: 1.2,
                                py: 0.4,
                                borderRadius: "6px",
                                background: "#DDFBEA",
                                color: "#00A651",
                                fontWeight: 700,
                                fontSize: 12,
                            }}
                        >
                            ATIVO
                        </Box>
                    </Box>

                    <Typography
                        sx={{
                            mt: 1,
                            color: "#555",
                            fontSize: {
                                xs: 14,
                                md: 16,
                            },
                        }}
                    >
                        Você tem acesso total a todas as ferramentas e suporte personalizado.
                    </Typography>

                    {/* Benefícios */}
                    <Box
                        sx={{
                            mt: 3,
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "1fr 1fr",
                            },
                            gap: 2,
                        }}
                    >
                        {[
                            "Notas Fiscais",
                            "Consultoria Tributária",
                            "Dashboard em Tempo Real",
                            "Atendimento via WhatsApp",
                        ].map((item) => (
                            <Box
                                key={item}
                                display="flex"
                                alignItems="center"
                                gap={1}
                            >
                                <CheckCircleOutlineIcon
                                    sx={{
                                        color: "#1ED760",
                                        fontSize: 22,
                                        flexShrink: 0,
                                    }}
                                />
                                <Typography
                                    sx={{
                                        fontSize: {
                                            xs: 14,
                                            sm: 16,
                                        },
                                    }}
                                >
                                    {item}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* Ações */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        width: {
                            xs: "100%",
                            md: "260px",
                        },
                        gap: 2,
                    }}
                >
                    {/* <Button
                        sx={{
                            background: "#172A45",
                            color: "#fff",
                            px: 5,
                            py: 1.8,
                            borderRadius: "14px",
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: {
                                xs: 15,
                                md: 17,
                            },
                            width: "100%",
                            "&:hover": {
                                background: "#13233B",
                            },
                        }}
                    >
                        Solicitar serviço
                    </Button> */}

                    <Typography
                        sx={{
                            color: "#B000FF",
                            fontWeight: 700,
                            cursor: "pointer",
                            textAlign: "center",
                            "&:hover": {
                                textDecoration: "underline",
                            },
                        }}
                        onClick={() => navigate("../dashboard/mudarPlano")}
                    >
                        Comparar planos
                    </Typography>
                </Box>
            </Box>
            <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="md">
                <img
                    src={imageUrl}
                    alt="preview"
                    style={{ width: "100%", height: "auto" }}
                />
            </Dialog>
            <Loading open={loading} />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
        </>
    )
}

export default Dashboard;